// Dubai - AC annual maintenance contract (AMC).
const content = {
    slug: 'ac-maintenance-contract',
    title: (c) => `AC Maintenance Contract Dubai (AMC) from ${c.money(c.tables.annual[0].threeTimes)}/year`,
    description: (c) =>
        `Yearly AC maintenance contract in Dubai: 3 or 4 cleaning visits at a fixed price, from ${c.money(c.tables.annual[0].threeTimes)} a year for one unit. Booked once, reminded each visit.`,
    eyebrow: 'Dubai · AC maintenance contract',
    h1: 'AC Maintenance Contract (AMC) in Dubai',
    lead: (c) =>
        `Three or four cleanings a year at one fixed price, booked once. For one split unit that is ${c.money(c.tables.annual[0].threeTimes)} a year for three visits - less than booking each visit separately.`,
    image: 'blog/living/aircon/chinese-aircon-service-man-smiling.jpg',
    imageAlt: 'Technician arriving for a scheduled AC maintenance visit',
    facts: ['3 or 4 visits a year', 'Fixed yearly price', 'Visits spread around summer'],
    priceTitle: 'AMC prices per year',
    priceIntro: 'Prices cover every visit in the year. The more units and visits, the bigger the saving over one-off bookings.',
    panel: { type: 'annual' },
    sections: [
        {
            title: 'How visits are spread in Dubai',
            steps: [
                { title: 'March or April', body: 'Before the heat. Filters, coil, drain and gas pressure checked so the unit starts summer clean.' },
                { title: 'July', body: 'Mid-summer. Units have been running non-stop for months; this visit catches clogged drains and dusty coils before they cause leaks.' },
                { title: 'October', body: 'End of the hottest stretch. Clears the summer\'s dust before the units get a lighter workload.' },
                { title: 'January (4-visit plan)', body: 'A winter check for homes that run AC all year or sit near construction dust.' },
            ],
        },
        {
            title: 'Who an AMC suits',
            tone: 'muted',
            cards: [
                { title: 'Villas and townhouses', body: 'Four to eight units are a lot to remember and coordinate. One contract covers them all.' },
                { title: 'Landlords', body: 'Many Dubai landlords keep AC upkeep on their side to protect the units. An AMC is a fixed cost you can plan for.' },
                { title: 'Busy tenants', body: 'If your contract makes cleaning your job, an AMC makes sure it actually happens - and keeps you on good terms at check-out.' },
            ],
        },
        {
            title: 'What a typical Dubai AMC does not include',
            paragraphs: [
                'An AMC here covers scheduled cleaning visits. Gas refills, chemical washes and repair parts are quoted separately when needed - we would rather show you exactly what each visit includes than bundle extras into a vague "comprehensive" price.',
            ],
        },
    ],
    faqs: [
        {
            question: 'How much is an AC maintenance contract in Dubai?',
            answer: (c) => `For one split unit, ${c.money(c.tables.annual[0].threeTimes)} a year for three visits or ${c.money(c.tables.annual[0].fourTimes)} for four. For three units, ${c.money(c.tables.annual[2].threeTimes)} a year for three visits.`,
        },
        {
            question: 'Is an AMC worth it?',
            answer: 'If you would otherwise book cleanings every few months, yes - the yearly price is lower than separate visits, and nobody has to remember to book.',
        },
        {
            question: 'Can I add a chemical wash to my AMC?',
            answer: 'Yes. Book it alongside one of your visits - usually the March or April one - and it is priced as a separate job.',
        },
    ],
    schema: {
        name: 'AC Annual Maintenance Contract in Dubai',
        serviceType: 'Air conditioner maintenance contract',
        offers: (c) => [
            { name: 'AMC, 1 unit, 3 visits a year', price: c.tables.annual[0].threeTimes },
            { name: 'AMC, 1 unit, 4 visits a year', price: c.tables.annual[0].fourTimes },
            { name: 'AMC, 3 units, 3 visits a year', price: c.tables.annual[2].threeTimes },
            { name: 'AMC, 5 units, 4 visits a year', price: c.tables.annual[4].fourTimes },
        ],
    },
}

export default content
